import Axios from 'axios'
import config from './config'

const apiUrls = {
  remote : config.passesRemoteApiUrl,
  local : config.passesLocalApiUrl 
}

const syncPasses = async ({apiSource,apiKeys,templateId}) => {
  try {
    let options = {
      method: 'POST',
      url: `${apiUrls[apiSource]}/syncPasses/${templateId}/true` // true = sync to Apple devices
    }

    const result = await callApi({apiSource,apiKeys,options})

    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error synchronising pass"}
  }
}


const makePass  = async ({ apiSource, apiKeys, apiMode, templateId, passId, passData}) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/makePass/${templateId}/${passId}`,
      method: "PUT",
      data : passData
    }

    let result = await callApi({apiSource,apiKeys, apiMode,options})

    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error making pass"}
  }
}

const getIssuedPasses =  async ({ apiSource, apiKeys, templateId, mode, startRow, maxRows}) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/getIssuedPasses/${templateId}/${startRow}/${maxRows}`,
      method: "GET"
    }

    let result = await callApi({apiSource,apiKeys,apiMode:mode,options})

    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error getting passes list"}
  }
}

const getPass =  async ({ apiSource, apiKeys, templateId,passId}) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/getPass/${templateId}/${passId}`,
      method: "GET"
    }

    let result = await callApi({apiSource,apiKeys,options})

    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:(err.response?.data?.error?.message ?? "Error getting pass")}
  }
}


const updatePass = async ({apiSource,apiKeys,templateId,passId,instance_data}) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/updatePass/${templateId}/${passId}/true`, // true = p[ush changes to Apple devices]
      method: "PUT",
      data:instance_data // Instance data must form the body, not be an attribute... 
    }

    let result = await callApi({apiSource,apiKeys,options})

    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:(err.response?.data?.error?.message ?? "Error updating pass")}
  }
}

const getPassNotifications = async ({apiSource,apiKeys,templateId,passId}) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/getPassNotifications/${templateId}/${passId}`,
      method: "GET"
    }

    let result = await callApi({apiSource,apiKeys,options})

    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error getting notifications"}
  }
}

const notifyPass = async ({apiSource,apiKeys,templateId,passId,notification}) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/notifyPass/${templateId}/${passId}`,
      method: "POST",
      data : {notification}
    }

    let result = await callApi({apiSource,apiKeys,options})

    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error notifying pass"}
  }
}

const notifyPasses = async ({apiSource,apiKeys,templateId,passes, notification}) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/notifyPasses/${templateId}`,
      method: "POST",
      data : {
        pass_ids:passes,
        notification
      }
    }

    let result = await callApi({apiSource,apiKeys,options})

    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error notifying passes"}
  }
}

const notifyAll = async ({apiSource,apiKeys,templateId,notification}) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/notifyAll/${templateId}`,
      method: "POST",
      data : {notification}
    }

    let result = await callApi({apiSource,apiKeys,options})

    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error notifying passes"}
  }
}



const getActivePassesCount = async ({apiSource,apiKeys}) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/getActivePassesCount`,
      method: "get"
    }

    let result = await callApi({apiSource,apiKeys,apiMode:"live",options})

    return result
  }
  catch (err) {
    console.error(err)
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error getting pass counts"}
  }
}

const deletePasses = async ({apiSource,apiKeys,apiMode, templateId, passes}) => {
  try {
    let options = {
      url: `${apiUrls[apiSource]}/deletePasses/${templateId}`,
      method: "delete",
      data : {passes}
    }

    let result = await callApi({apiSource,apiKeys,apiMode,options})

    return result
  }
  catch (err) {
    console.error(err)
    return {ok:false,error:err.response?.data?.error?.message ?? "Error deleting pass"}
  }
}


const callApi = async ({apiSource,apiKeys, apiMode,options}) => {
  try {
    const mode = apiMode ?? Object.keys(apiKeys)[0]

    if (apiSource === "local") {
      options.headers = {
        'x-api-key': config.localApiKey,
        'Authorization': apiKeys[mode],
        'Content-type': 'application/json',
      }
    } else {
      options.headers = {
        'x-api-key': apiKeys[mode],
        'Content-type': 'application/json',
      }
    }

    let response = await Axios(options)

    return response.data
  }
  catch (err) {
    throw err
  }
}


export {
  getActivePassesCount,
  getPass,
  getIssuedPasses,
  getPassNotifications,
  makePass,
  notifyAll,
  notifyPass,
  notifyPasses,
  syncPasses,
  updatePass,
  deletePasses,
}